import { services } from '../../services';
var action = "manage/property";

export const propertyService = {
    getList,
    getOne,
    updateMonlyBilling,
    keyHandOver,
    getDropdowns
    
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function updateMonlyBilling(object) {
    return services.restApi(`${action}/update/monlthy-billing-date`, 'POST', object);
}

function keyHandOver(object) {
    return services.restApi(`${action}/key-handover`, 'POST', object);
}

function getDropdowns(projectId = 0, status = '') {
    return services.restApi(`${action}/dropdown/${projectId}/${status}`, 'GET');
}


